var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvironment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6L10.079 6.05719C10.693 6.50163 11 6.72387 11 7C11 7.27613 10.693 7.49837 10.079 7.9428L10 8",
    stroke: "#313131",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4L7.5 6.99997L7 10",
    stroke: "#313131",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6L4.92099 6.05719C4.307 6.50163 4 6.72387 4 7C4 7.27613 4.307 7.49837 4.92099 7.9428L5 8",
    stroke: "#313131",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7C14 9.8284 14 11.2427 13.0481 12.1213C12.0962 13 10.5641 13 7.5 13C4.43587 13 2.9038 13 1.95191 12.1213C1 11.2427 1 9.8284 1 7C1 4.17157 1 2.75736 1.95191 1.87868C2.9038 1 4.43587 1 7.5 1C10.5641 1 12.0962 1 13.0481 1.87868C13.681 2.46293 13.8931 3.28393 13.9642 4.6",
    stroke: "#313131",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironment);
export default __webpack_public_path__ + "static/media/Environment.f8cf5ac0115293ca2ae113f99910628e.svg";
export { ForwardRef as ReactComponent };